module.exports = __webpack_public_path__ + "img/result_announce.98d1cc13.png";